import React, { useEffect, useState } from 'react'
import $ from "jquery";
import userImage from "../../assets/profile.png";
import EditIcon from "../../assets/edit-icon.svg";
import Close_white from "../../assets/white-close.svg";
import CloseDarkBlack from "../../assets/close-dark-black.svg";
import { onGetProfileDetails, onJustReducerUpdate } from '../../redux/action';
import { useDispatch, useSelector } from "react-redux";
import { HANDLE_IS_FIRST_TIME, REGISTER_DETAILS } from '../../redux/action_type';
import { onProfileUpdate } from '../../services';
import { useToast } from '../../toast';
import down_arrow_gray from "../../assets/down_arrow_gray.svg";
import { jsonWithDialCode, jsonWithoutDialCode } from "../../constants/countryList";
import _ from 'lodash';



function EditProfile() {
    const dispatch = useDispatch()
    let authData = localStorage.getItem(REGISTER_DETAILS)
    authData = JSON.parse(authData)
    const [name, setName] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [email, setEmail] = useState("")
    const [profileImage, setProfileImage] = useState("")
    const [profileUploadImage, setProfileUploadImage] = useState("")
    const profileDetails = useSelector((state) => state.profileDetails)
    const toast = useToast();
    const [search, setSearch] = useState("")
    const [countryList, setCountryList] = useState([])
    const [selectedCountry, setSelectedCountry] = useState({})
    const isFirstTime = useSelector((state) => state.isFirstTime)
    useEffect(() => {
        if (authData && Object.keys(authData)?.length != 0) {
            dispatch(onGetProfileDetails(authData.josh_user_id))
        }
    }, [])

    useEffect(() => {
        if (profileDetails) {
            if (profileDetails?.name?.toLowerCase().includes("guest") && !isFirstTime) {
                $("#edit-profile").modal("show")
            }
            setName(profileDetails.name)
            setPhoneNumber(profileDetails?.cp_creator_login_details?.[0]?.mobile_no)
            setEmail(profileDetails?.cp_creator_login_details?.[0]?.email)
            setProfileImage(profileDetails.user_image)
        }
    }, [profileDetails])

    useEffect(() => {
        if (!countryList || !profileDetails) {
            return
        }
        if (profileDetails.acc_type === "MOBILE" || profileDetails?.cp_creator_login_details?.[0]?.country_code) {
            setSelectedCountry(countryList.find(a => a.dial_code === profileDetails?.cp_creator_login_details?.[0]?.country_code) || {})
            return
        } else {
            setSelectedCountry({
                "name": "India",
                "code": "IN",
                "emoji": "🇮🇳",
                "unicode": "U+1F1EE U+1F1F3",
                "image": "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
                "dial_code": "+91"
            })
        }
    }, [profileDetails, countryList])


    useEffect(() => {
        let finalList = []
        jsonWithoutDialCode.map(val1 => {
            jsonWithDialCode.map(val2 => {
                if (val1.code === val2.code) {
                    finalList = [...finalList, { ...val1, ...val2 }]
                }
            })
        })
        setCountryList(finalList)
    }, []);
    const onFileChange = (e) => {
        if (e.target && e.target.files[0]) {
            setProfileImage(URL.createObjectURL(e.target.files[0]));
            setProfileUploadImage(e.target.files[0])
        }
    };
    const openModal = () => {
        if (profileDetails.acc_type === "MOBILE") {
            return
        }
        $("#country-popup").modal("show");
    };
    const onSubmitValue = (event) => {
        event.preventDefault();
        let authData = localStorage.getItem(REGISTER_DETAILS)
        authData = JSON.parse(authData)
        if (!authData) {
            return
        }
        let formData = new FormData();
        if (profileImage === "") {
            formData.append("file", "")
            formData.append("is_removeProfilePic", true)
        } else if (profileImage) {
            formData.append("file", profileUploadImage)
        }
        if (name?.toLowerCase().includes("guest")) {
            toast.open("Term 'guest' cannot be put in the username. Please enter a valid name.", "error")
            return
        }
        formData.append("email", email)
        formData.append("name", name)
        formData.append("country_code", selectedCountry.dial_code)
        formData.append("mobile_no", phoneNumber)
        if (profileDetails.name != name && profileDetails?.cp_creators?.length > 0) {
            $("#confirm-update-popup").modal("show")
            return
        }
        onProfileUpdate(formData).then((res) => {
            if (res.status) {
                dispatch(onJustReducerUpdate(false, HANDLE_IS_FIRST_TIME))
                $('.edit-profile').modal("hide");
                if (authData && Object.keys(authData)?.length != 0) {
                    dispatch(onGetProfileDetails(authData.josh_user_id))
                    toast.open("Profile updated successfully");
                }
            }
        })
    }

    const onClear = () => {
        if (profileDetails.name?.toLowerCase().includes("guest")) {
            toast.open("Term 'guest' cannot be put in the username. Please enter a valid name.", "error")
            return
        }
        $("#edit-profile").modal("hide")
        setName(profileDetails.name)
        setPhoneNumber(profileDetails?.cp_creator_login_details?.[0]?.mobile_no)
        setEmail(profileDetails?.cp_creator_login_details?.[0]?.email)
        setProfileImage(profileDetails.user_image)
    }

    const onRemoveCurrentPic = () => {
        setProfileImage("")
        setProfileUploadImage("")
    }
    const onCountryClose = () => {
        setSearch("")
        $("#country-popup").modal("hide");
    }
    const onCountrySelect = (data) => {
        setSelectedCountry(data)
        setSearch("")
        $("#country-popup").modal("hide");
    }

    const onConfirm = () => {
        let authData = localStorage.getItem(REGISTER_DETAILS)
        authData = JSON.parse(authData)
        if (!authData) {
            return
        }
        let formData = new FormData();
        if (profileImage === "") {
            formData.append("file", "")
            formData.append("is_removeProfilePic", true)
        } else if (profileImage) {
            formData.append("file", profileUploadImage)
        }
        formData.append("email", email)
        formData.append("name", name)
        formData.append("country_code", selectedCountry.dial_code)
        formData.append("mobile_no", phoneNumber)
        $("#confirm-update-popup").modal("hide")
        onProfileUpdate(formData).then((res) => {
            if (res.status) {
                dispatch(onJustReducerUpdate(false, HANDLE_IS_FIRST_TIME))
                $('.edit-profile').modal("hide");
                if (authData && Object.keys(authData)?.length != 0) {
                    dispatch(onGetProfileDetails(authData.josh_user_id))
                    if (!_.isEmpty(profileDetails?.cp_creators) && profileDetails?.cp_creators?.[0]?.is_linked) {
                        toast.open("Profile updated successfully. Please check your new social performance URL");
                    } else {
                        toast.open("Profile updated successfully");
                    }
                }
            }
        })
    }
    return (
        <>
            {/* Edit Profile HTML Start Here  */}
            <div
                className="modal fade edit-profile"
                id="edit-profile"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static" data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup modal-fullscreen-xl aboutus-popup" role="document">
                    <div className="modal-content   ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Edit Profile
                            </h5>
                            <button onClick={onClear} type="button" className="close">
                                <span className='displaySpan' aria-hidden="true">
                                    <img src={Close_white} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className='edit-profile-wrap'>
                                <form onSubmit={onSubmitValue}>
                                    <div className='user-image-wrap'>
                                        <div className='user-image-card'><img src={profileImage || userImage} alt="" /></div>
                                        <div className='edit-logo'>
                                            <div className="dropdown">
                                                <button
                                                    className="dropdown-toggle"
                                                    type="button"
                                                    id="dropdownMenuButton"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    <img className='' src={EditIcon} alt="" />

                                                </button>
                                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <div className="dropdown-item" >
                                                        <input type="file" accept="image/*" onChange={onFileChange} id='upload1' />
                                                        <label htmlFor="upload1">Choose from library</label>
                                                    </div>
                                                    {/* <div className="dropdown-item" >
                                                        <input type="file" onChange={onFileChange} id='upload2' />
                                                        <label htmlFor="upload2"> Take photo</label>
                                                    </div> */}
                                                    {profileDetails?.user_image && <div className="dropdown-item" onClick={onRemoveCurrentPic}>
                                                        <input type="button" id='upload3' />
                                                        <label htmlFor="upload3">  Remove current photo</label>
                                                    </div>}
                                                    <a className="dropdown-item">
                                                        Cancel
                                                    </a>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className='profile-form-wrap'>
                                        <div className="form-group">
                                            <label htmlFor="">Enter Your Name</label>
                                            <input style={{ border: profileDetails?.name?.includes("guest") ? "1px solid #fb5757" : "" }} className='form-control' maxLength={30} value={name} placeholder='Enter Your Name' type="text" onChange={(e) => setName(e.target.value)} />
                                        </div>
                                        <div className='form-group'>
                                            <label htmlFor="">Enter Your Mobile Number</label>
                                            <div className='form-group country-code-piker'>
                                                <div className="country-select" onClick={openModal}>
                                                    <img alt="down_arrow" src={selectedCountry.image}></img>
                                                    <span className='displaySpan'>{selectedCountry.dial_code}<img className="down-arrow" src={down_arrow_gray} alt="" /></span>
                                                </div>
                                                <input className='form-control'
                                                    value={phoneNumber}
                                                    onChange={(e) => {
                                                        if (profileDetails?.acc_type === "MOBILE") {
                                                            return
                                                        }
                                                        setPhoneNumber(e.target.value)
                                                    }} placeholder='Enter Your Mobile Number' type="text" />
                                                {profileDetails?.acc_type === "MOBILE" && <div className='varified'>Verified</div>}
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="">Enter Your Email</label>
                                            <input className='form-control' value={email} placeholder='Enter Your Email' type="email" onChange={(e) => {
                                                if (profileDetails?.acc_type !== "MOBILE") {
                                                    return
                                                }
                                                setEmail(e.target.value)
                                            }} />
                                        </div>
                                        <div className='common-btn'>
                                            {/* <button type='button' onClick={onClear}>Clear</button> */}
                                            <button type='submit'>Save</button>
                                        </div>
                                        <div
                                            className="modal fade"
                                            id="country-popup"
                                            tabIndex="-1"
                                            role="dialog"
                                            aria-labelledby="exampleModalLabel"
                                            data-backdrop="static" data-keyboard="false"
                                            aria-hidden="true"
                                        >
                                            <div className="modal-dialog modal-dialog-centered  custom-popup country-picker-modal" role="document">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title w-auto countryTitle" id="exampleModalLabel">
                                                            Select your country
                                                        </h5>
                                                        <button type="button" onClick={onCountryClose} className="close country-close">
                                                            <span className='displaySpan' aria-hidden="true">
                                                                <img src={CloseDarkBlack} alt="" />
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div className="modal-body popup-scroll p-0">
                                                        <div className="searchFilter">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter Country Name"
                                                                value={search}
                                                                onChange={(e) => setSearch(e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="country-list">
                                                            {countryList
                                                                .filter((value) => {
                                                                    if (search === "") {
                                                                        return value;
                                                                    } else if (
                                                                        value.name
                                                                            .toLowerCase()
                                                                            .includes(search.toLowerCase())
                                                                    ) {
                                                                        return value;
                                                                    }
                                                                })
                                                                .map((value, key) => {
                                                                    return (<div
                                                                        className="list"
                                                                        key={key}
                                                                        onClick={() => onCountrySelect(value)}
                                                                    >
                                                                        <img src={value.image} alt="" />
                                                                        {value.name}
                                                                    </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">

                        </div>
                    </div>
                </div>
                <div
                    className="modal fade logout-popup-wrap session-popup"
                    id="confirm-update-popup"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    data-backdrop="static"
                    data-keyboard="false"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                        <div className="modal-content   ">
                            <div className="modal-body pt-0 mt-3">
                                <div className='logout-card'>
                                    <p>Updating username will impact your media kit URL and will disable existing URL. If you proceed, we suggest updating the new URL everywhere.</p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className='common-btn'>
                                    <button className='bg-btn' onClick={onConfirm}>Confirm</button>
                                    <button onClick={() => $("#confirm-update-popup").modal("hide")} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Edit Profile HTML End Here  */}

        </>
    )
}

export default EditProfile